export default __webpack_public_path__ + "static/media/FiraSans-BoldItalic.b17b4285.ttf";